import { createFileRoute } from '@tanstack/react-router';
import { LoginLinkLandingPage } from '@pages/recovery';

export const Route = createFileRoute('/$locale/recovery/login-link/$recoveryRequestId')({
  component: LoginLinkRoute,
});

function LoginLinkRoute() {
  const { locale, recoveryRequestId } = Route.useParams();
  return (
    <LoginLinkLandingPage locale={locale as 'en' | 'ru'} recoveryRequestId={recoveryRequestId} />
  );
}
